<template>
  <page-outline :title="pageTitle">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <mq-series-credential-form v-model="config" :readonly="!editMode" :mode="mode" :idEngine="idEngine"></mq-series-credential-form>
    </template>
    <template slot="bottomActions">
      <app-button
        v-if="mode === 'create' && demo"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="createConfig">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === false && canEditConfig && demo"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        @click="editModeActivate">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === false && canDeleteConfig && demo"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        @click="deleteConfig">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === true && demo"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="editConfig">
      </app-button>
    </template>
  </page-outline>
</template>

<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import {loadPage} from '@/helpers/routing'
import MQSeriesCredentialForm from "@/pages/routing/MQSeries/MQSeriesCredentialForm.vue";

export default {
  name: 'MQSeriesCredentialForm',
  components: {
    'app-button': AppButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'mq-series-credential-form': MQSeriesCredentialForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    idEngine: {
      type: String,
      default: '0'
    },
    mode: {
      type: String,
      default: 'create'
    },
    entitiesType: {
      type: String,
      default: 'rvm'
    },
    role: {
      type: String,
    },
    IdConfigRouting: {
      type: String,
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.firstOn().rights.rightIs('mqseriesConfig_delete', true)
    },
    canEditConfig () {
      return this.$engine.firstOn().rights.rightIs('mqseriesConfig_edit', true)
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.mqseries_details') : this.$t('Webheader.mqseries_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      demo: true,
      returnUrl: '',
      savedConfig: []
    }
  },
  created () {
    this.returnUrl = `/routing/mqseriesListConfig/${this.idEngine}/${this.role}/${this.entitiesType}/${this.IdConfigRouting}`
    // if (this.entitiesType === 'rvm'){
    //   this.returnUrl = '/routing/mqseriesListConfig/' + this.role + '/rvm/' + this.IdConfigRouting
    // }
    // if (this.entitiesType === 'requester'){
    //   this.returnUrl = '/routing/mqseriesListConfig/' + this.role + '/requester/' + this.IdConfigRouting
    // }
    // if (this.entitiesType === 'responder'){
    //   this.returnUrl = '/routing/mqseriesListConfig/' + this.role + '/responder/' + this.IdConfigRouting
    // }
    this.activateSpinner = true
    if (this.mode === 'details') {
      this.savedConfig = this.$engine.get(this.idEngine).routing.config.clickedConfig
      this.fillFields()
      this.$engine.get(this.idEngine).routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
          selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.get(this.idEngine).security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type,
            idPod: this.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          this.$engine.get(this.idEngine).security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.ChannelName = this.config.channelName
            // params.ConnectionMode = this.config.connectionMode
            // params.ConnectionType = this.config.connectionType
            params.Timeout = this.config.timeout
            params.Host = this.config.host
            params.Name = this.config.name
            params.Port = this.config.port
            params.QueueManager = this.config.queueManager
            params.QueueName = this.config.queueName
            params.SSL = this.config.sslActive
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            this.$engine.get(this.idEngine).routing.config.mqseries.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          ChannelName: this.config.channelName,
          // ConnectionMode: this.config.connectionMode,
          // ConnectionType: this.config.connectionType,
          Timeout: this.config.timeout,
          Login: this.config.login,
          Password: this.config.password,
          PeerName: this.config.peerName,
          Repository: this.config.repository,
          Host: this.config.host,
          Name: this.config.name,
          Port: this.config.port,
          QueueManager: this.config.queueManager,
          QueueName: this.config.queueName,
          SSL: this.config.sslActive
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }
        this.$engine.get(this.idEngine).routing.config.mqseries.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMQSeries: that.savedConfig.IdMQSeries,
                Type: 'credential'
              }
              that.$engine.get(this.idEngine).routing.config.mqseries.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let modeSecurity = this.getmodeSecurity()

      let params = {
        ChannelName: this.config.channelName,
        Timeout: this.config.timeout,
        Login: this.config.login,
        Password: this.config.password,
        PeerName: this.config.peerName,
        Repository: this.config.repository,
        Type: 'credential',
        Host: this.config.host,
        IdMQSeries: this.savedConfig.IdMQSeries,
        Name: this.config.name,
        Port: this.config.port,
        QueueManager: this.config.queueManager,
        QueueName: this.config.queueName,
        SSL: this.config.sslActive,
        Keystore: this.config.keystore,
        CA: this.config.ca,
        ModeSecurity: modeSecurity,
        IdVopProvider: this.config.IdVopProvider,
        kdb: '(ENV:'+this.config.kdb+')',
        sth: '(ENV:'+this.config.sth+')',
        Active: this.config.active
      }
      this.$engine.get(this.idEngine).routing.config.mqseries.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: this.returnUrl})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_edition_error'))
      })
    },
    getmodeSecurity () {
      let modeSecurity = 0
      if (this.config?.controlConfig?.selectedVerif && Array.isArray(this.config.controlConfig.selectedVerif)) {
        if (this.config.controlConfig.selectedVerif.length !== 0){
          let dictionnary = {
            listVerifClientSSL: {
              1: { id: 1, text: this.$i18n.t('common.global.verify_peer'), value: 1 },
              2: { id: 2, text: this.$i18n.t('common.global.ctrl_CRL'), value: 32 },
              3: { id: 3, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 8 },
              4: { id: 4, text: this.$i18n.t('common.global.ctrl_key_size'), value: 16 },
              5: { id: 5, text: this.$i18n.t('common.global.ctrl_expiration'), value: 1024 },
              6: { id: 6, text: this.$i18n.t('common.global.ctrl_CN'), value: 2048 }
            },
            listVerifServerSSL: {
              7: { id: 7, text: this.$i18n.t('common.global.ctrl_CA'), value: 2 },
              8: { id: 8, text: this.$i18n.t('common.global.ctrl_CRL'), value: 256 },
              9: { id: 9, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 64 },
              10: { id: 10, text: this.$i18n.t('common.global.ctrl_key_size'), value: 128 },
              11: { id: 11, text: this.$i18n.t('common.global.ctrl_expiration'), value: 512 },
              12: { id: 12, text: this.$i18n.t('common.global.ctrl_CN'), value: 4096 }
            }
          }


          this.config.controlConfig.selectedVerif.forEach(element => {
            if (element > 6) {
              modeSecurity += dictionnary.listVerifServerSSL[element].value
            } else {
              modeSecurity += dictionnary.listVerifClientSSL[element].value
            }
          })
        }
      }

      return modeSecurity
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.active = this.savedConfig.Active
      this.config.channelName = this.savedConfig.ChannelName
      // this.config.connectionMode = this.savedConfig.ConnectionMode
      // this.config.connectionType = this.savedConfig.ConnectionType
      this.config.formatName = this.savedConfig.FormatName
      this.config.formatOutName = this.savedConfig.FormatOutName
      this.config.host = this.savedConfig.Host
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.queueManager = this.savedConfig.QueueManager
      this.config.queueName = this.savedConfig.QueueName
      this.config.sslActive = this.savedConfig.SSL
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
      this.config.peerName = this.savedConfig.PeerName
      this.config.repository = this.savedConfig.Repository
      this.config.timeout = this.savedConfig.TimeOut
      this.config.keystore = this.savedConfig.Keystore
      this.config.ca = this.savedConfig.CA
      this.config.controlConfig = this.savedConfig.controlConfig
      this.config.IdVopProvider = this.savedConfig.IdVopProvider
      this.config.kdb = this.savedConfig.kdb ? (this.savedConfig.kdb.match(/\(ENV:([^)]+)\)/)?.[1] || this.savedConfig.kdb) : ''
      this.config.sth = this.savedConfig.sth ? (this.savedConfig.sth.match(/\(ENV:([^)]+)\)/)?.[1] || this.savedConfig.sth) : ''
      //this.config.certificateConfig = this.savedConfig.certificateConfig
      //this.config.privateKeysConfig = this.savedConfig.privateKeysConfig
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if ( this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      // if (this.config.connectionMode === undefined || this.config.connectionMode.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.connection_mode_missing'))
      //   return true
      // }
      // if (this.config.connectionType === undefined || this.config.connectionType.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.connection_type_missing'))
      //   return true
      // }
      if (this.config.timeout === undefined || this.config.timeout.length === 0) {
        this.okMessageBox(this.$t('common.routing.timeout_missing'))
        return true
      }
      if (this.config.channelName === undefined || this.config.channelName.length === 0) {
        this.okMessageBox(this.$t('common.routing.channel_name_missing'))
        return true
      }
      if (this.config.queueName === undefined || this.config.queueName.length === 0) {
        this.okMessageBox(this.$t('common.routing.queue_name_missing'))
        return true
      }
      if (this.config.sslActive === undefined || this.config.sslActive !== '0' && this.config.sslActive !== '1') {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === '1') {
        // if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
        //   this.okMessageBox(this.$t('common.global.ctrl_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig === undefined) {
        //   this.okMessageBox(this.$t('common.security.certif_name_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
        //   this.okMessageBox(this.$t('common.security.certif_name_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
        //   this.okMessageBox(this.$t('common.security.certif_desc_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
        //   this.okMessageBox(this.$t('common.security.certif_type_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
        //   this.okMessageBox(this.$t('common.security.password_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
        //   this.okMessageBox(this.$t('common.security.password_verify_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
        //   this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
        //   this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
        //   return true
        // }
        // if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
        //   this.okMessageBox(this.$t('common.security.certif_cn_missing'))
        //   return true
        // }
        // if (this.config.privateKeysConfig === undefined) {
        //   this.okMessageBox(this.$t('common.securityffff'))
        //   return true
        // }
        // if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
        //   this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
        //   return true
        // }
        // if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
        //   this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
        //   return true
        // }
        // if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
        //   this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
        //   return true
        // }
        // if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
        //   this.okMessageBox(this.$t('common.security.password_missing'))
        //   return true
        // }
        // if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
        //   this.okMessageBox(this.$t('common.security.password_verify_missing'))
        //   return true
        // }
      }
      return false
    },
    goBack () {
      loadPage(this, {url: this.returnUrl})
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
  }
}
</script>
